import { i18n } from 'src/i18n';
import exporterFields from 'src/modules/resource/list/resourceListExporterFields';
import selectors from 'src/modules/resource/list/resourceListSelectors';
import ResourceService from 'src/modules/resource/resourceService';
import Errors from 'src/modules/shared/error/errors';
import Exporter from 'src/modules/shared/exporter/exporter';

const prefix = 'RESOURCE_LIST';

const resourceListActions = {
  FETCH_STARTED: `${prefix}_FETCH_STARTED`,
  FETCH_SUCCESS: `${prefix}_FETCH_SUCCESS`,
  FETCH_ERROR: `${prefix}_FETCH_ERROR`,

  RESETED: `${prefix}_RESETED`,
  SELECTEDS_CHANGED: `${prefix}_SELECTEDS_CHANGED`,

  PAGINATION_CHANGED: `${prefix}_PAGINATION_CHANGED`,
  SORTER_CHANGED: `${prefix}_SORTER_CHANGED`,

  EXPORT_STARTED: `${prefix}_EXPORT_STARTED`,
  EXPORT_SUCCESS: `${prefix}_EXPORT_SUCCESS`,
  EXPORT_ERROR: `${prefix}_EXPORT_ERROR`,

  doChangeSelected(payload) {
    return {
      type: resourceListActions.SELECTEDS_CHANGED,
      payload,
    };
  },

  doReset: (filter = {}, rawFilter = {}) => async (dispatch) => {
    dispatch({
      type: resourceListActions.RESETED,
    });

    await dispatch(
      resourceListActions.doFetch(filter, rawFilter),
    );
  },

  doExport: () => async (dispatch, getState) => {
    try {
      if (!exporterFields || !exporterFields.length) {
        throw new Error('exporterFields is required');
      }

      dispatch({
        type: resourceListActions.EXPORT_STARTED,
      });

      const filter = selectors.selectFilter(getState());
      const response = await ResourceService.list(
        filter,
        selectors.selectOrderBy(getState()),
        null,
        null,
      );

      new Exporter(
        exporterFields,
        i18n('entities.resource.exporterFileName'),
      ).transformAndExportAsExcelFile(response.rows);

      dispatch({
        type: resourceListActions.EXPORT_SUCCESS,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: resourceListActions.EXPORT_ERROR,
      });
    }
  },

  doChangePaginationAndSort:
    (pagination, sorter) => async (dispatch, _getState) => {
      dispatch({
        type: resourceListActions.PAGINATION_CHANGED,
        payload: pagination,
      });

      dispatch({
        type: resourceListActions.SORTER_CHANGED,
        payload: sorter,
      });

      dispatch(resourceListActions.doFetchCurrentFilter());
    },

  doFetchCurrentFilter:
    () => async (dispatch, getState) => {
      const filter = selectors.selectFilter(getState());
      const rawFilter = selectors.selectRawFilter(
        getState(),
      );
      dispatch(
        resourceListActions.doFetch(
          filter,
          rawFilter,
          true,
        ),
      );
    },

  doFetch:
    (filter?, rawFilter?, keepPagination = false) =>
    async (dispatch, getState) => {
      try {
        const parentResourceId = new URLSearchParams(
          window.location.search,
        )?.get('parentResourceId');

        if (!filter) {
          filter = {};
        }

        if (!rawFilter) {
          rawFilter = {};
        }

        if (parentResourceId) {
          filter.parentResource = parentResourceId;
        }

        dispatch({
          type: resourceListActions.FETCH_STARTED,
          payload: { filter, rawFilter, keepPagination },
        });

        const response = await ResourceService.list(
          filter,
          selectors.selectOrderBy(getState()),
          selectors.selectLimit(getState()),
          selectors.selectOffset(getState()),
        );

        dispatch({
          type: resourceListActions.FETCH_SUCCESS,
          payload: {
            rows: response.rows,
            count: response.count,
          },
        });
      } catch (error) {
        Errors.handle(error);

        dispatch({
          type: resourceListActions.FETCH_ERROR,
        });
      }
    },
};

export default resourceListActions;
